// extracted by mini-css-extract-plugin
export var column = "style-module--column--6ae43";
export var row = "style-module--row--57102";
export var table = "style-module--table--5da17";
export var th = "style-module--th--9fd77";